const lang = document.documentElement.getAttribute('lang');
const prevLabel = lang === 'sv' ? 'Föregående' : "Previous";
const nextLabel = lang === 'sv' ? 'Nästa' : "Next";

if (document.readyState !== 'loading') {
    initPagination();
} else {
    document.addEventListener("DOMContentLoaded", function () {
        initPagination();
    });
}

function initPagination() {
    const paginationListElement = document.querySelector(".search-result__pagination ul");
    const shouldSkipPaginationBlocks = document.querySelectorAll('.vgr-serviceportal-feed, .searchresultpagelistblock');

    if (shouldSkipPaginationBlocks.length > 0) return;

    const resultsPerPage = 10;
    const totalHitsInput = document.querySelector("input.totalHits") as HTMLInputElement;
    const totalHits = parseInt(totalHitsInput?.value || "0");
    const totalPages = Math.max(1, Math.ceil(totalHits / resultsPerPage));

    const currentPage = Math.min(parseInt(new URLSearchParams(window.location.search).get("p") || "1"), totalPages);
    const maxSurroundingPages = 2;

    if (isNaN(totalHits) || isNaN(currentPage) || currentPage <= 0) {
        console.error("Ogiltig data för totalHits eller aktuell sida");
        return;
    }

    // Dölj pagination om det bara finns en sida med träffar eller inga träffar alls
    if (totalHits <= resultsPerPage) {
        if (paginationListElement) paginationListElement.innerHTML = "";
        return;
    }

    const hiddenSearchParams = document.querySelectorAll('input[type="hidden"].AdditionalSearchParams, input[type="hidden"].projectsearch, input[type="hidden"].sort');
    const hiddenQueryFields = document.querySelectorAll('input[type="hidden"].Query');
    const queryParams = new URLSearchParams(window.location.search);

    const svgArrowPrev = `
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
            <path d="M4.2644 7.19313C3.81812 7.63941 3.81812 8.36416 4.2644 8.81044L11.1192 15.6653C11.5655 16.1116 12.2903 16.1116 12.7366 15.6653C13.1828 15.219 13.1828 14.4943 12.7366 14.048L6.68859 8L12.733 1.95202C13.1793 1.50575 13.1793 0.780989 12.733 0.334709C12.2867 -0.11157 11.562 -0.11157 11.1157 0.334709L4.26083 7.18956L4.2644 7.19313Z" fill="#005B89"/>
        </svg>`;

    const svgArrowNext = `
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
            <path d="M12.7366 7.19313C13.1828 7.63941 13.1828 8.36416 12.7366 8.81044L5.88171 15.6653C5.43543 16.1116 4.71068 16.1116 4.2644 15.6653C3.81812 15.219 3.81812 14.4943 4.2644 14.048L10.3124 8L4.26797 1.95202C3.82169 1.50575 3.82169 0.780988 4.26797 0.334709C4.71425 -0.11157 5.439 -0.11157 5.88528 0.334709L12.7401 7.18956L12.7366 7.19313Z" fill="#005B89"/>
        </svg>`;

    const createPaginationItem = (pageNumber: number, label: string, isPrev: boolean, isNext: boolean, isActive = false, iconSVG = '') => {
        const li = document.createElement("li");
        li.className = `page-item ${isActive ? "active" : ""}`;

        const link = document.createElement("a");
        link.className = "ignore-link-focus page-link";

        queryParams.set("p", pageNumber.toString());

        hiddenSearchParams?.forEach((field) => {
            const input = field as HTMLInputElement;
            if (input.name && input.value) {
                queryParams.set(input.name, input.value);
            }
        });

        hiddenQueryFields?.forEach((field) => {
            const input = field as HTMLInputElement;
            if (input.name && input.value) {
                queryParams.set(input.name, input.value);
            }
        });

        link.href = `?${queryParams.toString()}`;

        if (iconSVG) {
            link.innerHTML = isPrev
                ? iconSVG + `<span class="desktop-only-text">${prevLabel}</span>`
                : `<span class="desktop-only-text">${nextLabel}</span>` + iconSVG;
        } else {
            link.textContent = label;
        }

        li.appendChild(link);
        return li;
    };

    function createDots() {
        const dots = document.createElement("li");
        dots.className = "page-item disabled";
        dots.innerHTML = `<span class="ignore-link-focus page-link">...</span>`;
        return dots;
    }

    if (paginationListElement) {
        paginationListElement.innerHTML = "";

        const prevButton = createPaginationItem(
            currentPage - 1,
            shouldSkipPaginationBlocks.length === 0 ? prevLabel : "",
            true,
            false,
            false,
            svgArrowPrev
        );
        const link = prevButton.querySelector("a");

        if (currentPage === 1) {
            prevButton.classList.add("disabled");
            link?.setAttribute("aria-disabled", "true");
            link?.setAttribute("tabindex", "-1"); // Inaktivera tabb
        } else {
            prevButton.classList.remove("disabled");
            link?.removeAttribute("aria-disabled");
            link?.setAttribute("tabindex", "0"); // Aktivera tabb
        }

        paginationListElement.appendChild(prevButton);


        const firstPage = createPaginationItem(1, "1", false, false, currentPage === 1);
        paginationListElement.appendChild(firstPage);

        if (currentPage > maxSurroundingPages + 1) {
            paginationListElement.appendChild(createDots());
        }

        const startPage = Math.max(2, currentPage - maxSurroundingPages);
        const endPage = Math.min(totalPages - 1, currentPage + maxSurroundingPages);

        for (let i = startPage; i <= endPage; i++) {
            const pageItem = createPaginationItem(i, i.toString(), false, false, currentPage === i);
            paginationListElement.appendChild(pageItem);
        }

        if (currentPage < totalPages - maxSurroundingPages) {
            paginationListElement.appendChild(createDots());
        }

        const lastPage = createPaginationItem(totalPages, totalPages.toString(), false, false, currentPage === totalPages);
        paginationListElement.appendChild(lastPage);

        const nextButton = createPaginationItem(
            currentPage + 1,
            shouldSkipPaginationBlocks.length === 0 ? nextLabel : "",
            false,
            true,
            false,
            svgArrowNext
        );
        const nextlink = nextButton.querySelector("a");

        if (currentPage === totalPages) {
            nextButton.classList.add("disabled");
            nextlink?.setAttribute("aria-disabled", "true");
            nextlink?.setAttribute("tabindex", "-1");
        } else {
            nextButton.classList.remove("disabled");
            nextlink?.removeAttribute("aria-disabled");
            nextlink?.setAttribute("tabindex", "0");
        }

        paginationListElement.appendChild(nextButton);
    }
}
